module.exports = __webpack_public_path__ + "img/advance-2-1.svg";